import { getLineIdsOfSubItems } from "../../../utils/cart/orderLineMenuIds";
import { SuccessReportTypes } from "../../../utils/ErrorTypes";
import { SubItemType } from "../../../utils/types";
import type { AppDispatch, RootState } from "../app/store";
import { selectLoyaltyCartLines } from "../selectors/loyaltyCartSelectors";
import { receiptErrorAction } from "../slices/cartLoyaltyV2Slice";

export const removeRejectedCartLines =
  (
    errorType:
      | SuccessReportTypes.ReceiptController_ConfirmReceipt_ReqItemsContainsOutDatedItems
      | SuccessReportTypes.ItemService_ValidateOutOfStockSubItemIds_ReqItemsContainsOutOfStock,
    rejectedSubItems: SubItemType[]
  ) =>
  (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();

    dispatch(
      receiptErrorAction({
        errorType,
        lineIds: getLineIdsOfSubItems(
          selectLoyaltyCartLines(state),
          state.config.subItemLookupByUuid ?? {},
          rejectedSubItems
        ),
        outOfStockItems: [],
      })
    );
  };
